<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'bankAccountDetails',
    components: {
      baseEdit,
    },
  };
</script>
